






























import CommonButton from '@/components/button/CommonButton.vue';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import SyncApi from '@/api/SyncApi';
import {Component, Mixins} from 'vue-property-decorator';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import '@/plugins/Modal';
import TextInput from '@/components/input/TextInput.vue';
import {CDMSItemSelectDialogRequest} from '@/model/CommonModel';
import SelectDialogMixin from '@/components/dialog/SelectDialogMixin';
import IconButton from '@/components/button/IconButton.vue';
import DefaultComponentMixin from '@/views/DefaultComponentMixin';

@Component({
        components: {
            CommonButton,
            CommonPromptDialog,
            TextInput,
            IconButton,
        },
        mixins: [DialogEventsMixin, SelectDialogMixin, DefaultComponentMixin]
    })
    export default class SelectCDMSItemDialog extends Mixins(DialogEventsMixin, SelectDialogMixin, DefaultComponentMixin) {
        protected loading: boolean = true;
        private index: number;
        private itemTreeData = [
            {
                id: '',
                label: '',
                property: {
                    itemKey: '',
                    pageLabel: '',
                    verKey: '',
                    type: ''
                },
                type: '',
                children: [
                    {
                        id: '',
                        label: '',
                        property: {
                            itemKey: '',
                            pageLabel: '',
                            verKey: '',
                            type: ''
                        },
                        type: '',
                        children: [
                            {
                                id: '',
                                label: '',
                                property: {
                                    itemKey: '',
                                    pageLabel: '',
                                    verKey: '',
                                    type: ''
                                },
                                type: '',
                                children: [
                                    {
                                        id: '',
                                        label: '',
                                        type: '',
                                        property: {
                                            itemKey: '',
                                            pageLabel: '',
                                            verKey: '',
                                            type: ''
                                        },
                                        children: []
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ];

        get ITEM_TYPE() {
          return 'ITEM';
        }
        
        get isVisible() {
            return this.visible;
        }
        
        get getWidth() {
            return this.width;
        }
        
        private defaultProps = {
            children: 'children',
            label: 'label',
        };
        
        public mounted() {
            this.$modal
                .getEventBus()
                .$on('showCDMSItemTreeDialog', (params: CDMSItemSelectDialogRequest) => {
                    this.show(params);
                });
            
            this.$modal.getEventBus().$on('hideCDMSItemTreeDialog', () => this.onCancel());
        }
        
        public show(request: CDMSItemSelectDialogRequest) {
            this.visible = true;
            this.loading = true;
            this.index = request.index;
    
            SyncApi.retrieveCDMSTreeItem(this.$route.params.sponsorKey, this.$route.params.studyKey)
                   .then((res: any) => {
                       if (!res.success) {
                           return Promise.reject(res.errMsg);
                       }
        
                       this.itemTreeData = res.data;
                   })
                   .catch((errMsg) => this.afterRequestFail(errMsg))
                   .finally(() => this.loading = false);
        }
        
        public search() {
            (this.$refs.tree as any).filter(this.getCaseInsensitiveWord(this.keyword));
        }
        
        public filterNode(value: any, data: any, node: any) {
            if (!value) {
                return true;
            }
            return this.getCaseInsensitiveWord(data.label)?.indexOf(value) !== -1;
        }

        public getCaseInsensitiveWord(word: string) {
            return word?.trim().toUpperCase();
        }
        
        public onClickNode(data: any, node: any) {
          if (data.type.toUpperCase() === this.ITEM_TYPE) {
            data.index = this.index;
            this.$emit('selectedCDMSItem', data);
            this.visible = false;
          }
        }
    
        public onSearch() {
            this.search();
        }
        
        public onCancel() {
            this.visible = false;
        }
        
        public afterClosed() {
            this.visible = false;
            this.loading = true;
            this.keyword = '';
        }
        
        public destroyed() {
            this.$modal.getEventBus().$off('showCDMSItemTreeDialog');
            this.$modal.getEventBus().$off('hideCDMSItemTreeDialog');
        }
    }
